import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import {
  Avatar,
  Button,
  Menu,
  MenuItem,
  useMediaQuery,
} from '@material-ui/core'
import AppBar from '@material-ui/core/AppBar'
import React, { useState } from 'react'
import {
  createStyles,
  makeStyles,
  Theme,
  useTheme,
} from '@material-ui/core/styles'
import { User } from '../../types/User'
import { authService } from '../../utils/fbase'
import { Link } from 'react-router-dom'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      flexGrow: 1,
    },
    menuButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    },
    title: {
      flexGrow: 1,
    },
    small: {
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
  })
)

interface props {
  handleDrawerToggle: () => void
  user: User | null
  showDrawer: boolean
}

export default function Header({
  showDrawer,
  handleDrawerToggle,
  user,
}: props): JSX.Element {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const theme = useTheme()
  const matchesSM: boolean = useMediaQuery(theme.breakpoints.down('sm'))

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleLogout = () => {
    setAnchorEl(null)
    authService.signOut()
  }

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const CustomLink = (props: JSX.IntrinsicAttributes) => (
    <Link to={'/'} {...props}>
      Sign In
    </Link>
  )

  const getMainLogoLeftMargin = (): string => {
    if (showDrawer) {
      return '-10px'
    } else {
      if (matchesSM) {
        return ''
      } else {
        return '-10px'
      }
    }
  }
  return (
    <AppBar position="fixed" className={classes.appBar} color={'primary'}>
      <Toolbar>
        {showDrawer && (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
        )}
        <div className={classes.title}>
          <Link to={'/'}>
            <img
              src={
                'https://ik.imagekit.io/crso3ztbifq/todobe/todobe_main_logo_crop_Kaum3u0xL.jpeg'
              }
              width={'112px'}
              style={{
                verticalAlign: 'middle',
                marginLeft: getMainLogoLeftMargin(),
              }}
              alt={'main_logo'}
            />
          </Link>
        </div>
        {user && (
          <div>
            <Avatar
              alt={user?.name}
              src={user?.photoUrl}
              className={classes.small}
              onClick={handleMenu}
            />

            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={open}
              onClose={handleClose}
            >
              <MenuItem onClick={handleLogout}>Log Out</MenuItem>
            </Menu>
          </div>
        )}
        {!user && (
          <div>
            <Button color={'inherit'} component={CustomLink} />
          </div>
        )}
      </Toolbar>
    </AppBar>
  )
}
